import CodeMirror from "codemirror";

// When using ESM modules, CodeMirror has a legacy way to include addons
// https://github.com/codemirror/CodeMirror/issues/5403#issuecomment-392852397
window.CodeMirror = CodeMirror;
